export const START_HIGHER_LOWER_COMPLETED = "higherLower/startCompleted";
export const GUESS_HIGHER_LOWER_COMPLETED = "higherLower/guessCompleted";
export const GET_HIGHER_LOWER_STATUS_COMPLETED = "higherLower/statusCompleted";
